module.exports = __webpack_public_path__ + "img/gcclogo.b23e4d44.png";